import { createAction } from '@'
import FetchMappingCoverage from './FetchMappingCoverage'
import { $coverageCatalogs } from '../stores'

export default createAction('GetCatalogs', async (force = false) => {
    const cached = $coverageCatalogs.getState()
    if (cached && !force) {
        return cached
    }
    const data = await FetchMappingCoverage({ method: 'GET', path: '/catalogs' })
    $coverageCatalogs.setState(() => data.catalogs || [])
    return $coverageCatalogs.getState()
})
